import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext.js';
import './ViewNote.css';

export default function ViewNote() {
  const { noteId } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem('jwtToken');
  const { isAuthenticated, userInfo } = useAuth();
  const [note, setNote] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  axios.defaults.withCredentials = true;

  useEffect(() => {
    const fetchNote = async () => {
      setIsLoading(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/notes/getbynoteid/${noteId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setNote(res.data);
      } catch (err) {
        console.error(err);
        setError('Kon notitie niet laden.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchNote();
  }, [noteId, token]);

  if (!isAuthenticated) return <p>Niet ingelogd.</p>;
  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="view-note-container">
      <h2>Notitie Details</h2>
      <div className="view-note-meta">
        <span>Datum: {new Date(note.noteDate).toLocaleDateString()}</span>
        <span>Aangemaakt door: {note.createdBy}</span>
      </div>
      <div className="view-note-content">
        <p>{note.content}</p>
      </div>
      <div className="view-note-actions">
        <button onClick={() => navigate(-1)} className="btn-back">
          Terug
        </button>
        {userInfo?.role !== 'docent' && (
          <button
            onClick={() => navigate(`/notes/update/${noteId}`)}
            className="btn-edit"
          >
            Bewerk
          </button>
        )}
      </div>
    </div>
  );
}